import React from "react";

function RightsReserved({ text }) {
  return (
    <div className="rights-reserved-text">{text !== undefined ? text : ""}</div>
  );
}

export default RightsReserved;
